module.exports = __webpack_public_path__ + "img/nunito-sans-v6-latin-300.a2ce20cb.svg";